/**
 * StickyFooterPosition.ABSOLUTE is only used for
 * fullscreen modals, callout and drawers which is automatically
 * set if fl-sticky-footer is a content child of fl-sticky-footer-wrapper.
 *
 * This is to fix issues in older IOS versions where position fixed
 * elements inside scrollable containers either shakes or hide during scrolling
 */
export enum StickyFooterPosition {
  ABSOLUTE = 'absolute',
  FIXED = 'fixed',
}
